import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';
 
const SubmodClassForm = ({ submodClassId, initialData, onSuccess }) => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    
  const [submodClassName, setSubmodClassName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
 
  // ✅ Fill form if initialData is provided (edit mode)
  useEffect(() => {
    if (initialData && initialData.mod_name) {
      setSubmodClassName(initialData.mod_name);
    }
  }, [initialData]);
 
  const handleSubmit = async (e) => {
    e.preventDefault();
 
    if (!submodClassName.trim()) {
      setError('SubmodClass name is required');
      return;
    }
 
    setLoading(true);
    setError('');
 
    try {
      let url = '';
      let method = 'POST';
      let body = {};
 
      if (submodClassId) {
        // ✅ Edit mode
        url = `${baseUrl}/updateSubmodClassById/${submodClassId}`;
        body = { mod_name: submodClassName };
      } else {
        // ✅ Create mode
        url = `${baseUrl}/createSubmodClass`;
        body = { mod_name: submodClassName };
      }
 
      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
 
      const data = await response.json();
 
      if (data.status) {
        alert(submodClassId ? 'SubmodClass updated successfully' : 'SubmodClass created successfully');
        if (onSuccess) onSuccess();
        navigate('/submodClass');
      } else {
        setError(data.message || `Failed to ${submodClassId ? 'update' : 'create'} SubmodClass`);
      }
    } catch (err) {
      setError('Error connecting to server');
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <form className="general-info-form" onSubmit={handleSubmit}>
      <h2 className="section-title">{submodClassId ? 'Edit SubmodClass' : 'Add SubmodClass'}</h2>
      <div className="form-grid">
        <div className="form-floating">
          <input
            type="text"
            className="form-control"
            id="submodClassName"
            placeholder=" "
            autoComplete="off"
            value={submodClassName}
            onChange={(e) => setSubmodClassName(e.target.value)}
            disabled={loading}
          />
          <label htmlFor="submodClassName">SubmodClass Name</label>
        </div>
      </div>
      {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
      <button
        type="submit"
        className="btn btn-primary"
        style={{ marginTop: '15px' }}
        disabled={loading}
      >
        {loading ? 'Saving...' : 'Save'}
      </button>
    </form>
  );
};
 
export default SubmodClassForm;